import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { 
  ClaimsConnection, 
  OrganizationsConnection, 
  PayloadOfCompletedSuccess, 
  RbsMutationSetAccountLoginDateClaimArgs,
  RbsQueryClaimsArgs,
  RbsQueryOrganizationsArgs, 
  } from './rbs.types';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class RbsService {
  private serverUrl : string = environment.graphql.rbs.url;
  
  constructor(
    private http: HttpClient,
    private auth: OAuthService,
  ) {
  }
  private graphqlUrl = this.serverUrl;

  queryOrganizations(
    input: RbsQueryOrganizationsArgs
  ): Observable<OrganizationsConnection> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.auth.getAccessToken()}`
    });    

    return this.http.post<any>(this.graphqlUrl, {
      query: query_Organizations,
      variables: input
    }, { headers: headers });
  }

  queryUserClaims(
    input: RbsQueryClaimsArgs
  ): Observable<ClaimsConnection> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.auth.getAccessToken()}`
    });    

    return this.http.post<any>(this.graphqlUrl, {
      query: query_Claims,
      variables: input
    }, { headers: headers });
  }


  mutationSetAccountLoginDateClaim(
    input: RbsMutationSetAccountLoginDateClaimArgs
  ): Observable<PayloadOfCompletedSuccess> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.auth.getAccessToken()}`
    });    

    return this.http.post<any>(this.graphqlUrl, {
      query: set_Account_Login_Date_Claim,
      variables: input
    }, { headers: headers });
  }
}

//
// todo:: *if this grows more than a few, move to a separate file*
//
export const set_Account_Login_Date_Claim =
`mutation SetAccountLoginDateClaim($userid: UUID!, $orgid: UUID!) {
    setAccountLoginDateClaim(userid: $userid, orgid: $orgid) {
      data{
        completed
    }
    errors{
        message
        extensions{
            errorCode
            propertyName
            attemptedValue
            severity
        }
      }
    }
  }
`;

export const query_Organizations =`
query organizations($first: Int, $after: String, $last: Int, $before: String, $where: OrganizationFilterInput, $order: [OrganizationSortInput!]){
    organizations(first: $first, after: $after, last: $last, before: $before, where: $where, order: $order){
        pageInfo{
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            cursor
        }
        nodes{
            orgName
            orgCode
            tpaRule
            tpaRuleFilter
            orgType
            requireMFA
            dateUpdated
            id
            claimPrefix
            dateStart
            dateExpire
            dateCreated
        }
        totalCount
    }
}
`;

export const query_Claims =`
query claims($first: Int, $after: String, $last: Int, $before: String, $where: ClaimFilterInput, $order: [ClaimSortInput!]){
    claims(first: $first, after: $after, last: $last, before: $before, where: $where, order: $order){
        pageInfo{
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            cursor
        }
        nodes{
            id
            parentId
            key
            value
            isPublic
            dateStart
            dateExpire
            dateCreated
        }
        totalCount
    }
}
`;